import { useMemo } from 'react';

import { resolveAdminTerminology } from 'utils/admin-terminology';

import { useAdminConfig } from './use-admin-config';

export function useAdminTerminology() {
  const { config, configQuery } = useAdminConfig();
  const terminology = useMemo(
    () => resolveAdminTerminology(config?.adminTerminology),
    [config?.adminTerminology]
  );
  return {
    terminology,
    refetch: configQuery.refetch,
    queries: { terminology: configQuery },
  };
}
